<!--  -->
<template>
<div class='layout'>
   <ul class="list" v-show="show">
       <li v-for="item in list" :key="item.id" @click="switchScene(item)">{{item.position}}</li>
   </ul>
    <div class="position" @click="showList()">
        <i class="icon"></i>当前位置：{{position}} <i class="arrow"></i>
    </div>
</div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
name: "ui-position",
//import引入的组件需要注入到对象中才能使用
components: {},
data() {
//这里存放数据
return {
    show:false,
    
}
},
//监听属性 类似于data概念
computed: {},
//监控data中的数据变化
watch: {},
//方法集合
methods: {
    
},
//生命周期 - 创建完成（可以访问当前this实例）
created() {

},
//生命周期 - 挂载完成（可以访问DOM元素）
mounted() {

},
beforeCreate() {}, //生命周期 - 创建之前
beforeMount() {}, //生命周期 - 挂载之前
beforeUpdate() {}, //生命周期 - 更新之前
updated() {}, //生命周期 - 更新之后
beforeDestroy() {}, //生命周期 - 销毁之前
destroyed() {}, //生命周期 - 销毁完成
activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang='less' scoped>
//@import url(); 引入公共css类
    .list {
        position:absolute;
        right:2vw;
        height:8.4vw;
        bottom:calc(2.8vw + 20px);
        background:rgba(0,0,0,0.3);
        padding:0 2vw;
        border-radius:1vw;
        li {
            line-height:2.8vw;
            height:2.8vw;
            color:#e6e5e5;
            cursor:pointer;
            &:hover {
                color:#a51f24;
            }
        }
    }
    .position {
        position:absolute;
        right:2vw;
        bottom:18px;
        background:rgba(0,0,0,0.3);
        height:2.8vw;
        line-height:2.8vw;
        border-radius:2vw;
        color:#e6e5e5;
        padding:0 2vw;
        font-size:1.3vw;
        padding-left:4vw;
        padding-right:4vw;
        cursor:pointer;
        .icon {
            display:inline-block;
            width:2.34vw;
            height:3.64vw;
            background:url(../../assets/img/position_icon.png) center/100% no-repeat;
            position:absolute;
            bottom:0.2vw;
            left:1vw;
        }
        .arrow {
            position:absolute;
            top:0.2vw;
            right:1.5vw;
            &:after {
                content:'';
                display:inline-block;
                width:0px;
                height:0px;
                border-top: 8px solid #e6e5e5;
                border-right:6px solid transparent;
                border-bottom:4px solid transparent;
                border-left:6px solid transparent;
            }
        }
    }
</style>